/* eslint-disable consistent-return */
import React, { useEffect, useState } from 'react';

// REDUX ACTION
import store, { history } from 'app/store';
import { isMobileOnly } from 'react-device-detect';
import {
  fetchTours,
  fetchDreamTours,
} from 'actions/Menu/folders-async.actions';
import { useSelector } from 'react-redux';
import { useActions } from 'app/components/Utility/hooks/useAction.hooks';

// HISTORY
import * as types from '../../../actions/action_types';
// ANT DESIGN

// COMPONENT
import NewMainMenu from './Newmenu';

// MOBILE COMPONENT
import MobileMenu from '../../Mobile/MainMenu/menu';

// JSON
import jsonMainMenu from './mainMenuJSON';

// API
import tourPrevAPI from '../../../API/tour.prev.api';
import pageDataAPI from '../../../API/pageData.api';
// CHECK DEVICES

// CSS
import './menu.css';
import { getTourId } from '../../Utility/utility';

const MainMenuItems = jsonMainMenu.items;

const Keys = () => {
  const Keys = [];
  for (const i of MainMenuItems) {
    if (i.isopen === true) {
      Keys.push(i.id);
    }
  }
  return Keys;
};

const defaultOpenKeys = () => {
  const defaultKeys = [];
  for (const i of MainMenuItems) {
    if (Object.hasOwnProperty.call(i, 'isopen') === true && i.isopen === true) {
      defaultKeys.push(i.id);
    }
  }
  return defaultKeys;
};

const displaySelectFriend = (val) => {
  MainMenuItems.forEach((item) => {
    if (item.id === '7') {
      item.visible = val;
    }
  });
};

let prevRouter;
const NewMenu = (props) => {
  const { callback } = props;

  const {
    loginModalOpen,
    loginIsLogin,
    openModalTourDownload,
    mainMenuCollapse,
    cleanPreviewTourData,
    cleanPreviewPolyTourData,
    getTours,
  } = useActions();

  const isLoggedIn = useSelector((store) => store.authentication.isLoggedIn);
  const authUserData = useSelector((store) => store.authentication.user);
  const modalOpen = useSelector((store) => store.loginData.modalOpen);
  const downloadTourGps = useSelector((store) => store.tourDownload);
  const router = useSelector((store) => store.router);
  const collapse = useSelector((store) => store.mainMenuData.collapse);
  const isTourDataLoaded = useSelector((store) => store.tourFullData.fetched);
  const index = useSelector((store) => store.userReducer.index);

  const [openKeys, setOpenKeys] = useState(Keys());
  const [selectedKeys, setSelectedKeys] = useState(['']);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileDrawerWidth, setMobileDrawerWidth] = useState('0');
  const [tableOpen, setTableOpen] = useState(false);
  const [openMyFolders, setOpenMyFodlers] = useState(false);
  const [openDreamFolders, setOpenDreamFolders] = useState(false);
  const { search, pathname } = router.location;
  const width = window.innerWidth;

  const isMobile = width < 768;
  const isTable = width <= 1024 && width >= 768;

  const openMyFoldersFc = (val) => {
    if (val) {
      setOpenKeys(['40']);
    } else {
      setOpenKeys(openKeys.filter((e) => e !== '40'));
    }
    setOpenMyFodlers(val);
  };

  const openDreamFoldersFc = (val) => {
    if (val) {
      setOpenKeys(['2']);
    } else {
      setOpenKeys(openKeys.filter((e) => e !== '2'));
    }
    setOpenDreamFolders(val);
  };

  useEffect(() => {
    callback();
    fetchDreamTours();
    MainMenuItems.forEach((item) => {
      if (pathname.indexOf(item.url) > -1 && item.items.length === 0) {
        if (item.id === '6') {
          displaySelectFriend(true);
        }

        setOpenKeys([item.id]);
        setSelectedKeys([item.id]);
      } else {
        item.items.forEach((child) => {
          if (pathname.indexOf(child.url) > -1) {
            setSelectedKeys([child.id]);
            setOpenKeys([item.id]);
          }
        });
      }
    });

    if (pathname !== '/createtour/' && pathname !== '/createtour') {
      mainMenuCollapse(false);
    }
  }, []);

  useEffect(() => {
    if (search === '?scope=academy') {
      mainMenuCollapse(true);
    }
  }, [search]);

  const changeOpenKeys = (val) => setOpenKeys(val);

  useEffect(() => {
    if (prevRouter !== router && prevRouter) {
      MainMenuItems.forEach((item) => {
        if (pathname.indexOf(item.url) > -1 && item.items.length === 0) {
          if (item.id === '6') {
            displaySelectFriend(true);
          }
          if (item.id === '4') {
            if (openMyFolders) setOpenKeys(['40']);
          } else if (item.id === '1') {
            if (openDreamFolders) setOpenKeys(['2']);
          } else {
            setOpenKeys([item.id]);
          }
          setSelectedKeys([item.id]);
        } else {
          item.items.forEach((child) => {
            if (pathname.indexOf(child.url) > -1) {
              setSelectedKeys([child.id]);
              setOpenKeys([item.id]);
            }
          });
        }
      });
    }
    prevRouter = router;
    if (pathname.indexOf('/member/profile') > -1) {
      setSelectedKeys(['23']);
    }
    if (index === 0 && pathname === '/') {
      mainMenuCollapse(true);
    }
  }, [router]);

  useEffect(() => {
    if (!collapse) {
      MainMenuItems.forEach((item) => {
        item.items.forEach((child) => {
          if (pathname.indexOf(child.url) > -1) {
            changeOpenKeys([item.id]);
          }
        });
      });
      if (openMyFolders) {
        changeOpenKeys(['40']);
      }
    }
  }, [collapse]);

  useEffect(() => {
    if (width < 1024) {
      setOpenKeys([]);
    }
  }, [width]);

  const openDelay = () => {
    if (collapse) {
      if (pathname === '/createtour/' || pathname === '/createtour') {
        return 1;
      }
      return 0.4;
    }
    return 0;
  };

  const openMainSectionOfMenu = (key) => {
    const mainKeys = () => {
      return key === '8' || key === '14' || key === '19';
    };
    MainMenuItems.forEach((item) => {
      if (mainKeys() && item.id === key) {
        const url = `${item.url}/list`;
        history.push(url);
      }
    });
  };

  const onOpenChange = (openKeys) => {
    const latestOpenKey = openKeys[openKeys.length - 1];
    openMyFoldersFc(false);
    if (
      latestOpenKey === '8' ||
      latestOpenKey === '14' ||
      latestOpenKey === '19'
    ) {
      openMainSectionOfMenu(latestOpenKey);
    }
    if (collapse) {
      setOpenKeys(openKeys);
      return;
    }
    if (openKeys[openKeys.length - 1] === '5') {
      setOpenKeys(['40']);
      return;
    }
    if (openKeys[0] === '1' && openKeys[1]) {
      setOpenKeys([openKeys[0], openKeys[openKeys.length - 1]]);
      return;
    }
    setOpenKeys([openKeys[openKeys.length - 1]]);
  };

  const uploadFriendTourById = (id) => {
    cleanPreviewTourData();
    cleanPreviewPolyTourData();

    if (id === 'All') {
      pageDataAPI.getMyFriendsTours().then((res) => getTours(res));
    } else {
      tourPrevAPI
        .getToursInfoByUserId(id)
        .then((res) => {
          const { code, response } = res;
          if (code === 200) {
            getTours(response);
          } else {
            console.log(res);
          }
        })
        .catch((err) => console.log(err));
    }
  };

  const loadFolderContent = (e) => {
    const folderId = e.key.split('_')[0];
    const applying = e.key.split('_')[1];
    const userId = authUserData.id || 0;
    store.dispatch((dispatch) => {
      dispatch({ type: types.FETCH_PREVIEW_DATA_CLEANE });
      dispatch({ type: types.FETCH_PREVIEW_POLYLINE_CLEANE });
      dispatch(fetchTours(folderId, userId, applying));
    });
  };

  const isFolderItem = (e) => {
    const { key } = e;
    const scope = key.split('_').slice(-1)[0];
    return scope === 'place' || scope === 'tour';
  };

  const onClickFc = ({ key, domEvent }) => {
    domEvent.preventDefault();
    domEvent.stopPropagation();
    if (
      key === '4' &&
      (domEvent.target.classList[0] === 'ant-menu-submenu-arrow' ||
        domEvent.target.classList[0] === 'ant-menu-submenu-arrow-layout')
    ) {
      openMyFoldersFc(!openMyFolders);
    }

    if (
      key === '1' &&
      (domEvent.target.classList[0] === 'ant-menu-submenu-arrow' ||
        domEvent.target.classList[0] === 'ant-menu-submenu-arrow-layout')
    ) {
      openDreamFoldersFc(!openDreamFolders);
    }
  };

  const selectedKeysFunc = (e) => {
    if (isFolderItem(e)) {
      loadFolderContent(e);
      setSelectedKeys([e.key]);
      return;
    }

    if (e.key !== '4' && e.key !== '5') {
      openMyFoldersFc(false);
    }

    if (e.key !== '1') {
      openDreamFoldersFc(false);
    }

    if (
      e.key === '1' &&
      (e.domEvent.target.classList[0] === 'ant-menu-submenu-arrow' ||
        e.domEvent.target.classList[0] === 'ant-menu-submenu-arrow-layout')
    ) {
      e.domEvent.preventDefault();
      e.domEvent.stopPropagation();
      openDreamFoldersFc(true);
      return;
    }

    if (
      e.key === '4' &&
      (e.domEvent.target.classList[0] === 'ant-menu-submenu-arrow' ||
        e.domEvent.target.classList[0] === 'ant-menu-submenu-arrow-layout')
    ) {
      e.domEvent.preventDefault();
      e.domEvent.stopPropagation();
      openMyFoldersFc(true);
      return;
    }

    if (e.key === '6') {
      displaySelectFriend(true);
    } else if (e.key === '7') {
      e.domEvent.preventDefault();
      return;
    } else {
      displaySelectFriend(false);
    }

    setSelectedKeys([e.key]);
    setMobileOpen(false);
    setMobileDrawerWidth('0');
    setTableOpen(false);

    cleanPreviewTourData();
  };
  //

  // MOBILE ACTION
  const onMobileOpenChange = () => {
    setMobileOpen(!mobileOpen);
    setMobileDrawerWidth(mobileOpen ? '0' : '100%');
  };

  //
  // TABLET ACTION
  const onTableOpenChange = () => setTableOpen(!tableOpen);

  //
  const isTourPage = () => {
    const { pathname } = router.location;
    const tourId =
      pathname && pathname.indexOf('/tour/') > -1 ? getTourId(router) : 0;
    return (
      pathname === '/createtour/' ||
      pathname === '/createtour' ||
      (tourId && !pathname.match('/folders')) ||
      (index === 0 && pathname === '/') ||
      pathname.indexOf('/pro') > -1 ||
      pathname.indexOf('/payment') > -1
    );
  };

  const prop = {
    dataMainMenu: MainMenuItems,
    openKeys,
    selectedKeys,
    onSelect: (e) => selectedKeysFunc(e),
    defaultOpenKeys: defaultOpenKeys(),
    onOpenChange,
    collapse: isTable ? true : collapse,
    mainMenuCollapse,
    isFullHeight: isTourPage(),
    isTable,
    authUserData,
    uploadFriendTourById,
    index,
    openDelay,
    router,
    isLoggedIn,
    onMobileOpenChange,
    onTableOpenChange,
    modalOpen,
    downloadTourGps,
    loginModalOpen,
    loginIsLogin,
    openModalTourDownload,
    isTourDataLoaded,
    mobileDrawerWidth,
    mobileOpen,
    openMyFolders,
    onClickFc,
    openMyFoldersFc,
    openDreamFolders,
    openDreamFoldersFc,
  };

  const component =
    isMobile || isMobileOnly ? (
      <MobileMenu {...prop} />
    ) : (
      <NewMainMenu {...prop} />
    );

  return component;
};

export default NewMenu;
